window.ecosystemPhases = window.ecosystemPhases || [
  {
    id: 'ep-1',
    title: 'Vulnerability',
  },
  {
    id: 'ep-2',
    title: 'Exploitation',
  },
  {
    id: 'ep-3',
    title: 'Prevention',
  },
  {
    id: 'ep-4',
    title: 'Safety',
  },
  {
    id: 'ep-5',
    title: 'Empowerment',
  },
  {
    id: 'ep-6',
    title: 'Prosecution',
  },
  {
    id: 'ep-7',
    title: 'Policy',
  },
];
window.causes = window.causes || [
  'Abuse prevention',
  'Adoption',
  'Antidiscrimination',
  'Basic and Emergency Aid',
  'Child abuse',
  'Child welfare',
  'Community and economic development',
  'Community health care',
  'Courts',
  'Crime prevention',
  'Crisis intervention',
  'Cybercrime',
  'Domestic violence',
  'Domestic violence shelters',
  'Economic development',
  'Economic justice',
  'Economics',
  'Emergency care',
  'Emergency medical services',
  'Family counseling',
  'Family disability resources',
  'Family planning',
  'Family services',
  'Foster care',
  'Foundations',
  'Freedom from slavery',
  'Group homes',
  'Health care clinics',
  'Homeless services',
  'Homeless shelters',
  'Human rights',
  'Human services',
  'Human services management',
  'Individual liberties',
  'International development',
  'Justice rights',
  'Juvenile justice',
  'Law enforcement',
  'Maternal and perinatal health',
  'Patient social services',
  'Philanthropy',
  'Public affairs',
  'Public safety',
  'Rehabilitation',
  'Rehabilitation of offenders',
  'Reproductive health care',
  'Safety education',
  'Sexual abuse',
  'Sexual assault victim services',
  'Sexually transmitted disease control',
  'Shelter and residential care',
  'Sheltered workshops',
  'Student services',
  'Substance abuse treatment',
  'Supportive housing',
  'Technology',
  'Unknown or not classified',
  'Victim aid',
  "Women's rights",
  'Youth development',
  'Youth mentoring',
  'Youth services',
];
window.ecosystemRoles = window.ecosystemRoles || [
  {
    id: '1',
    title: 'Child',
    description:
      'This is the description of the ecosystem role. It should describe the unique characteristics of this role within the specific context of this issue.',
  },
  {
    id: '2',
    title: 'Trafficker',
  },
  {
    id: '3',
    title: 'Buyer',
  },
  {
    id: '4',
    title: 'Law Enforcement',
  },
  {
    id: '5',
    title: 'Philanthropist',
  },
  {
    id: '6',
    title: 'Agency',
  },
  {
    id: '7',
    title: 'Legislator',
  },
];

window.ecosystemActivities = window.ecosystemActivities || [
  {
    id: 'ea-1',
    title: 'Grooming',
    roles: ['1', '2'],
    description:
      'This is a description of this ecosystem activity, describing how it uniquely relates to the specific context of this issue, and perhaps touching on what organizations are actively working towards in this area.',
  },
  {
    id: 'ea-2',
    title: 'Rape',
  },
  {
    id: 'ea-3',
    title: 'Rescue',
  },
  {
    id: 'ea-4',
    title: 'Trauma',
  },
  {
    id: 'ea-5',
    title: 'System Involvement',
  },
  {
    id: 'ea-6',
    title: 'Identification',
  },
  {
    id: 'ea-7',
    title: 'Legal Help',
  },
  {
    id: 'ea-8',
    title: 'Therapy',
  },
  {
    id: 'ea-9',
    title: 'Intercept',
  },
  {
    id: 'ea-10',
    title: 'Rescue',
  },
  {
    id: 'ea-11',
    title: 'Arrest',
  },
  {
    id: 'ea-12',
    title: 'Education',
  },
  {
    id: 'ea-13',
    title: 'Draft Legislation',
  },
  {
    id: 'ea-14',
    title: 'Foster Care',
  },
  {
    id: 'ea-15',
    title: 'Awareness',
  },
  {
    id: 'ea-16',
    title: 'Safe Houses',
  },
  {
    id: 'ea-17',
    title: 'New Life',
  },
  {
    id: 'ea-18',
    title: 'Adverse Childhood Experiences',
    roles: ['1'],
  },
  {
    id: 'ea-19',
    title: 'Divorce',
  },
  {
    id: 'ea-20',
    title: 'Child Welfare',
    roles: ['1'],
  },
  {
    id: 'ea-21',
    title: 'Runaway',
  },
  {
    id: 'ea-22',
    title: 'Juvenile Detention',
  },
  {
    id: 'ea-23',
    title: 'Sexual Assault',
  },
  {
    id: 'ea-24',
    title: 'Hospital Visits',
  },
  {
    id: 'ea-25',
    title: 'Abortion',
  },
  {
    id: 'ea-26',
    title: 'Mental Health Challenges',
  },
  {
    id: 'ea-27',
    title: 'Clinic Visits',
  },
  {
    id: 'ea-28',
    title: 'Optimism',
  },
  {
    id: 'ea-29',
    title: 'New Job',
  },
  {
    id: 'ea-30',
    title: 'UNKNOWN',
  },
  {
    id: 'ea-31',
    title: 'Pregnancy',
  },
  {
    id: 'ea-32',
    title: 'Substance Abuse',
  },
  {
    id: 'ea-33',
    title: 'Hotel Room Visits',
  },
  {
    id: 'ea-34',
    title: 'Homeless Shelters',
  },
  {
    id: 'ea-35',
    title: 'Abuse',
  },
  {
    id: 'ea-36',
    title: 'Slavery',
  },
  {
    id: 'ea-37',
    title: 'Investigation',
  },
  {
    id: 'ea-38',
    title: 'Evidence Collection',
  },
  {
    id: 'ea-39',
    title: 'Testifying',
  },
  {
    id: 'ea-40',
    title: 'UNKNOWN',
  },
  {
    id: 'ea-41',
    title: 'Payment',
  },
  {
    id: 'ea-42',
    title: 'Trafficking',
  },
  {
    id: 'ea-43',
    title: 'CSAM',
  },
  {
    id: 'ea-44',
    title: 'Pregnancy',
  },
  {
    id: 'ea-45',
    title: 'Molestation',
  },
  {
    id: 'ea-46',
    title: 'Testifying',
  },
  {
    id: 'ea-47',
    title: 'Investigation',
  },
  {
    id: 'ea-48',
    title: 'Investigation',
  },
  {
    id: 'ea-49',
    title: 'Incarceration',
  },
  {
    id: 'ea-50',
    title: 'Locate',
  },
  {
    id: 'ea-51',
    title: 'Arrest',
  },
  {
    id: 'ea-52',
    title: 'Continued Care',
  },
  {
    id: 'ea-53',
    title: 'Incarceration',
  },
  {
    id: 'ea-54',
    title: 'Education',
  },
  {
    id: 'ea-55',
    title: 'Economic Stability',
  },
  {
    id: 'ea-56',
    title: 'Job Training',
  },
  {
    id: 'ea-57',
    title: 'Media Engagement',
  },
  {
    id: 'ea-58',
    title: 'Housing',
  },
  {
    id: 'ea-59',
    title: 'Advocacy',
  },
  {
    id: 'ea-60',
    title: 'Housing',
  },
  {
    id: 'ea-61',
    title: 'Move to New Location',
  },
  {
    id: 'ea-62',
    title: 'Mentorship',
  },
];

window.ecosystemSegments = window.ecosystemSegments || [
  {
    id: 'prevention',
    title: 'Prevention',
    description:
      "Prevention efforts adopt an 'upstream' approach, concentrating on averting instances before they occur by safeguarding at-risk children, including those affected by foster care, and exposing or deterring potential buyers/sellers.",
    focusAreas: [
      'online-exploitation',
      'training',
      'foster-care',
      'education',
      'stakeholder-coordination',
      'shelter',
      'research-and-policies',
    ],
    interventions: ['1', '2', '3', '4', '5', '6', '7'],
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: 'rescue',
    title: 'Rescue',
    description:
      'Rescue operations aim to intervene in instances of CSEC. At a basic level, this requires removing victims from dangerous situations and apprehending buyers and sellers.',
    focusAreas: ['law-and-justice', 'victim-care', 'education'],
    interventions: ['8', '9', '10'],
    color: '#B9954D',
    lightenBackgroundAmount: 37,
  },
  {
    id: 'rehabilitation',
    title: 'Rehabilitation',
    description:
      'Survivors of CSEC endure profound trauma, and in response, comprehensive rehabilitation initiatives, including housing, employment, and counseling, are in place to guide them through the intricate process of healing.',
    focusAreas: ['employment', 'shelter', 'education'],
    interventions: ['11', '12', '13', '14', '15'],
    color: '#79AFE6',
    lightenBackgroundAmount: 24,
  },
  {
    id: 'ecosystem-capacity-building',
    title: 'Ecosystem Capacity Building',
    description:
      'Ecosystem Capacity Building aims to enhance collaboration between nonprofits, government agencies, and corporations at various levels, recognizing that a seamless partnership is pivotal for diminishing the impact of CSEC globally.',
    focusAreas: ['victim-care', 'education', 'stakeholder-coordination', 'fund'],
    interventions: ['16'],
    color: '#385692',
    lightenBackgroundAmount: 53,
  },
];

window.ecosystemInterventions = window.ecosystemInterventions || [
  {
    id: '1',
    title: 'Reduce vulnerabilities of potential victims',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '2',
    title: 'Educate potential victims on trafficking',
    description:
      'Children face significant risks of trafficking, whether through family members, adult acquaintances, or online exploitation. Raising awareness among children and their caregivers is crucial for prevention. Understanding that seemingly safe avenues can be exploited is vital. Educating children, caregivers, and educators about the widespread demand in the sex trafficking industry is essential. This awareness helps individuals comprehend the scale of the issue and the necessity of taking proactive measures for protection. Moreover, educating children about ways to protect themselves is vital in deterring trafficking situations. Equally critical is training caregivers and educators to properly identify and respond to children in need.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '3',
    title: 'Intercept and rescue victims en route',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '4',
    title: 'Identify, expose, and prosecute traffickers',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '5',
    title: 'Disrupt OSEC transaction',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '6',
    title: 'Identify, expose, and prosecute buyers',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '7',
    title: 'Intervene to reduce demand non-punitively',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '8',
    title: 'Identify victims',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '9',
    title: 'Rescue victims',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '10',
    title: 'Remove CSAM from internet',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '11',
    title: 'Coordinate care plan for survivors',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '12',
    title: 'Care for survivors, one-by-one',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '13',
    title: 'Reintegration care and ongoing counseling',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '14',
    title: 'Improve quality of care in safe houses',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '15',
    title: 'Empower survivors to be advocates',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
  {
    id: '16',
    title: 'Coordinate and strengthen local ecosystems',
    description: 'This is the description of the ecosystem intervention.',
    color: '#EB6C2C',
    lightenBackgroundAmount: 38,
  },
];

window.focusAreas = window.focusAreas || [
  {
    id: 'online-exploitation',
    title: 'Online Exploitation',
    description: 'Services include identifying and ending sexual exploitation photos and videos online',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
  },
  {
    id: 'foster-care',
    title: 'Foster Care',
    description: 'Services include recruiting and strengthening foster families and children',
    ecosystemSegments: ['prevention'],
  },
  {
    id: 'training',
    title: 'Training',
    description:
      'Services include educating first responders and community orgs to identify and support potential victims',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
  },
  {
    id: 'employment',
    title: 'Employment',
    description: 'Services include training and job placement for at-risk individuals or survivors',
    ecosystemSegments: ['prevention', 'rehabilitation'],
  },
  {
    id: 'education',
    title: 'Education',
    description: 'Services include educating at-risk individuals and victims',
    ecosystemSegments: ['prevention', 'rescue', 'rehabilitation', 'ecosystem-capacity-building'],
  },
  {
    id: 'stakeholder-coordination',
    title: 'Stakeholder Coordination',
    description: 'Services include resourcing and catalyzing collaboration in communities',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
  },
  {
    id: 'shelter',
    title: 'Shelter',
    description: 'Services include providing housing for victims',
    ecosystemSegments: ['prevention', 'rehabilitation', 'ecosystem-capacity-building'],
  },
  {
    id: 'research-and-policies',
    title: 'Research and Policies',
    description: 'Services include trend analysis and advocacy',
    ecosystemSegments: ['prevention'],
  },
  {
    id: 'law-and-justice',
    title: 'Law and Justice',
    description:
      'Services include strengthening justice systems and prosecution of sellers and buyers of sexual exploitation',
    ecosystemSegments: ['rescue', 'ecosystem-capacity-building'],
  },
  {
    id: 'victim-care',
    title: 'Victim Care',
    description: 'Services include supporting victims and coordination of services',
    ecosystemSegments: ['rescue', 'ecosystem-capacity-building'],
  },
  {
    id: 'fund',
    title: 'Fund',
    description: 'Services include resourcing and strengthening orgs who address CSEC',
    ecosystemSegments: ['ecosystem-capacity-building'],
  },
];

window.organizations = window.organizations || [
  {
    id: 'international-network-of-hearts',
    type: '',
    name: 'International Network of Hearts',
    mission:
      'To restore the lives of survivors of human trafficking and prevent commercial sexual exploitation and forced labor through increased awareness, training, advocacy and collaboration at an interdisciplinary and international level.',
    ecosystemSegments: ['prevention', 'rehabilitation'],
    focusAreas: ['training', 'shelter', 'education', 'stakeholder-coordination', 'victim-care'],
    keyActivities: [
      'Providing a safe, confidential home where survivors can find hope and refuge from violence.',
      'Creating a nurturing and structured environment where survivors can heal from years of trauma.',
      'Giving survivors the needed tools so they can achieve their highest potential.',
      'Raising international awareness about human trafficking.',
      'Providing training to law enforcement and other first responders in the identification of victims.',
      'Building multi-agency protocols to improve the response to victims of human trafficking.',
    ],
    geography: ['San Diego', 'Mexico'],
    budget: '$330K (2022)',
    yearsInOperation: 14,
    url: 'https://inhearts.org/',
    ein: '45-4234721',
    address: '2416 Riviera Dr Chula Vista, CA 91915',
    charityNavigatorRating: 0.53,
    ecosystemInterventions: ['11', '12'],
    recommendedBy: [],
    logo: '/s/network-of-hearts.png',
    latitude: 32.6356,
    longitude: -116.95555,
  },
  {
    id: 'children-of-the-immaculate-heart',
    type: '',
    name: 'Children of the Immaculate Heart',
    mission:
      "Children of the Immaculate Heart exists to serve survivors of sex trafficking through housing and rehabilitation programs as a part of the Church's mission to restore all things in Christ. ",
    ecosystemSegments: ['rehabilitation'],
    focusAreas: ['education', 'shelter', 'victim-care'],
    keyActivities: [
      "St. Bakhita's Program includes housing, case management, education, and therapy, and we partner with other organizations to provide medical and psychiatric care.",
      'The Emergency Services Program is a mobile clinic with a physical Drop-in Center in the city of San Diego that houses basic emergency food, clothing, toiletries and pamphlets used to seek services.',
    ],
    geography: ['San Diego'],
    budget: '$1.2M (2022)',
    yearsInOperation: 9,
    url: 'https://www.childrenoftheimmaculateheart.org/',
    ein: '46-3954106',
    address: 'P.O. Box 13954 San Diego, CA 92170',
    charityNavigatorRating: 0.66,
    ecosystemInterventions: ['12', '13'],
    recommendedBy: [],
    logo: '/s/children-of-the-immaculate-heart.png',
    latitude: 32.69697,
    longitude: -117.13425,
  },
  {
    id: 'CSA-San-Diego',
    type: '',
    name: 'CSA San Diego',
    mission:
      'Our mission is to promote social justice and public welfare through advocacy against all forms of discrimination, including but not limited to advocacy for the eradication of housing discrimination to assure equal housing opportunity for all individuals. ',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
    focusAreas: ['education', 'research-and-policies', 'stakeholder-coordination'],
    keyActivities: [
      'Assisting in the recovery of lost wages',
      'Enforcing fair labor laws such as the Employment Authorization Document Form I-765',
      'Strengthening and building collaborative network',
      'Prosecution of Traffickers',
      'Prevention of Child Trafficking',
    ],
    geography: ['San Diego'],
    budget: '$850K (2022)',
    yearsInOperation: 13,
    url: 'https://www.c4sa.org/human-trafficking',
    ein: '27-3317344',
    address: '327 Van Houten Ave El Cajon, CA 92020',
    charityNavigatorRating: 0.69,
    ecosystemInterventions: ['2', '16'],
    recommendedBy: [],
    logo: '/s/CSA-san-diego-county.png',
    latitude: 32.79224,
    longitude: -116.96612,
  },
  {
    id: 'Alabaster-Jar-Project',
    type: '',
    name: 'Alabaster Jar Project',
    mission:
      'It is now comprised of Grace House, a long-term residential program; a Resource Center, a drop-in center that provides clothing, toiletries, programming and Peer Support Group.',
    ecosystemSegments: ['rescue'],
    focusAreas: ['education', 'employment', 'shelter', 'victim-care'],
    keyActivities: [
      'A safe home environment based on a community living model (Grace House).',
      'Educational and vocational skills and opportunities.',
      'Foster overall wellness and self-understanding through personal and spiritual growth.',
    ],
    geography: ['San Diego'],
    budget: '$540K (2022)',
    yearsInOperation: 10,
    url: 'https://www.alabasterjarproject.org/',
    ein: '46-3504411',
    address: 'PO Box 501378, San Diego, CA 92150',
    charityNavigatorRating: 0.71,
    ecosystemInterventions: ['12', '13', '15'],
    recommendedBy: [],
    logo: '/s/alabaster-jar-project.png',
    latitude: 32.98515,
    longitude: -117.08185,
  },
  {
    id: 'GenerateHope',
    type: '',
    name: 'GenerateHope',
    mission:
      'We serve sex trafficking victims by offering a real way out. GenerateHope is a faith-based organization providing long-term, comprehensive programs to women who have been sexually trafficked, so that they are able to reintegrate into society and walk powerfully into their futures. ',
    ecosystemSegments: ['rescue'],
    focusAreas: ['education', 'employment', 'shelter', 'victim-care'],
    keyActivities: [
      'Long-Term, Safe Housing in a compassionate environment.',
      'Recovery Individual Psychotherapy and EMDR, group sessions, and trauma-informed curriculum like Ending the Game to heal from the trauma of the sex trade.',
      'Learning Center GED, college prep, tutoring, life skills, and living-wage career readiness',
      'Case Management Access to social, medical and support services.',
    ],
    geography: ['San Diego'],
    budget: '$1.6M (2022)',
    yearsInOperation: 15,
    url: 'https://www.generatehope.org/',
    ein: '26-3405689',
    address: '4025 Camino del Rio South Suite 300 San Diego, CA 92108',
    charityNavigatorRating: 0.83,
    ecosystemInterventions: ['11', '12', '13'],
    recommendedBy: ["San Diego Women's Foundation", 'Hope for San Diego', 'Alliance Healthcare Foundation'],
    logo: '/s/generate-hope.png',
    latitude: 32.77749,
    longitude: -117.10755,
  },
  {
    id: 'Bilateral-Safety-Corridor-Coalition',
    type: '',
    name: 'Bilateral Safety Corridor Coalition (BSCC)',
    mission:
      'They operate a hotline for victims of human trafficking, provide case management for survivors, and educates the community on human trafficking risks.',
    ecosystemSegments: ['prevention', 'rehabilitation', 'rescue'],
    focusAreas: ['education', 'shelter', 'victim-care'],
    keyActivities: [
      'Emergency Services: A 24/7 hotline in partnership with the San Diego Human Trafficking Task Force (SDHTTF).',
      'Emergency housing to more than 500 international/domestic survivors since 2005.',
      'Through a program of Encourage, Empower, and Excellence, BSCC motivates and provides training its clients to be self-sufficient and gain confidence on their abilities.',
      'BSCC works collaboratively with diverse community partners addressing health, trauma, economic empowerment, and legal service providers.',
    ],
    geography: ['San Diego'],
    budget: '$480K (2022)',
    yearsInOperation: 21,
    url: 'https://bsccoalition.org/',
    ein: '55-0806460',
    address: '121 E. 31st St. Suite A, National City, CA 91950',
    charityNavigatorRating: 0.84,
    ecosystemInterventions: ['2', '8', '11', '12', '13'],
    recommendedBy: ['STAT!', 'San Diego HT Task Force', 'IVAT'],
    logo: '/s/bscc.png',
    latitude: 32.65683339388195,
    longitude: -117.09772605887133,
  },
  {
    id: 'Free-to-Thrive',
    type: '',
    name: 'Free to Thrive',
    mission:
      'Free to Thrive empowers survivors of human trafficking to be free from exploitation and to thrive by providing them with holistic and trauma-informed legal and support services in collaboration with our service partners, and by increasing access to justice for all survivors. ',
    ecosystemSegments: ['rescue', 'ecosystem-capacity-building'],
    focusAreas: ['education', 'law-and-justice', 'research-and-policies', 'training'],
    keyActivities: [
      'Legal Services: We assist survivors with removing legal barriers on their journey to freedom.',
      'Education: We train stakeholders and provide case support to attorneys working with survivors to create a more survivor-centered and trauma-informed legal system. We also aim to prevent human trafficking, identify survivors and connect them to supportive services through our community training programs.',
      'Policy advocacy',
    ],
    geography: ['San Diego'],
    budget: '$1.3M (2022)',
    yearsInOperation: 7,
    url: 'https://www.freetothrive.org/',
    ein: '82-0860894',
    address: '1050 University Ave #E107-84 San Diego, CA 92103',
    charityNavigatorRating: 0.88,
    ecosystemInterventions: ['12', '16'],
    recommendedBy: [
      'Alabaster Jar Project',
      'Children of the Immaculate Heart',
      'North County Lifeline',
      'IVAT',
      'Generate Hope',
      'San Diego Youth Foundation',
    ],
    logo: '/s/free-2-thrive.png',
    latitude: 32.74979294166771,
    longitude: -117.15465386071885,
  },
  {
    id: 'IVAT',
    type: '',
    name: 'IVAT',
    mission:
      'Our mission is to promote violence-free living by improving the quality of life for individuals on local, national and international levels by sharing and disseminating vital information, improving cross-discipline collaborations, conducting research and trainings, and providing direct professional services, program evaluation, and consulting. ',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
    focusAreas: ['education', 'research-and-policies', 'training'],
    keyActivities: [
      'Provides speciality certification in trauma care and family court professionals, among others',
      'Runs journals on topics including child custody and child sexual abuse',
      'Provides clinical psychology services and forensic evaluations',
    ],
    geography: ['San Diego'],
    budget: '$1.4M (2021)',
    yearsInOperation: 32,
    url: 'https://www.ivatcenters.org/',
    ein: '75-2401334',
    address: '10065 Old Grove Rd Ste 101 San Diego, CA 92131',
    charityNavigatorRating: 0.9,
    ecosystemInterventions: ['1', '16'],
    recommendedBy: [],
    logo: '/s/ivat.png',
    latitude: 32.898728080726194,
    longitude: -117.11014983187799,
  },
  {
    id: 'Childrens-Legal-Services-of-San-Diego',
    type: '',
    name: "Children's Legal Services of San Diego",
    mission:
      'To protect and defend the rights of children and youth in the child welfare system through high-quality and compassionate legal representation. CLSSD is a non-profit, interdisciplinary organization that consists of four law firms, which are court-appointed to represent both minors and non-minor dependents injuvenile dependency court within and out of San Diego county. ',
    ecosystemSegments: ['rescue'],
    focusAreas: ['law-and-justice'],
    keyActivities: [
      'Provide direct legal represetation for juveniles',
      'Advocate for non-minor dependents (NMDs) through pro bono',
      'Prepare Care Bags for foster children entering or moving within the San Diego foster care system',
    ],
    geography: ['San Diego'],
    budget: '$4.1M (2022)',
    yearsInOperation: 7,
    url: 'https://www.clssandiego.org/',
    ein: '81-3389364',
    address: '4801 Viewridge Ave San Diego, CA 92123',
    charityNavigatorRating: 0.96,
    ecosystemInterventions: ['15'],
    recommendedBy: ["San Diego Women's Foundation"],
    logo: '/s/childrens-legal-sevices.png',
    latitude: 32.82587288734095,
    longitude: -117.12081421653727,
  },
  {
    id: 'North-County-Lifeline',
    type: '',
    name: 'North County Lifeline',
    mission:
      'Lifeline’s mission is to build self-reliance among youth, adults, and families through high-quality, community-based services. ',
    ecosystemSegments: ['prevention', 'rehabilitation', 'rescue'],
    focusAreas: ['education', 'foster-care', 'shelter', 'training', 'victim-care'],
    keyActivities: [
      'Project LIFE provides victims with initial trauma-informed emergency response, safety planning, intensive case management and behavioral health services.',
      'Project LIFE facilitates groups and workshops for youth addressing the behaviors that make them vulnerable to trafficking/commercial sexual exploitation, how recruiters operate, how to recognize and avoid gender-based violence, and how to get help for someone who may be at risk.',
      'Project LIFE conducts awareness trainings to educate professionals and the community members that this is a local issue that requires a local response.',
      'LifeSpring is a supportive housing program designed especially for youth and young adults who are exiting the foster care systems.',
    ],
    geography: ['San Diego'],
    budget: '$13M (2021)',
    yearsInOperation: 51,
    url: 'https://lifelinecs.org/',
    ein: '95-2794253',
    address: '200 Michigan Ave Vista, CA 92084',
    charityNavigatorRating: 0.96,
    ecosystemInterventions: ['1', '2', '8', '11', '12'],
    recommendedBy: [
      'San Diego HT Task Force',
      "San Diego Women's Foundation",
      'Free to Thrive',
      'BSCC',
      'SD Youth Service',
      'Alabaster Jar Project',
      'Point Loma University',
    ],
    logo: '/s/north-county-lifeline.png',
    latitude: 33.20372169332367,
    longitude: -117.24220177419618,
  },
  {
    id: 'San-Diego-Youth-Services',
    type: '',
    name: 'San Diego Youth Services (SDYS)',
    mission: 'San Diego Youth Services mission is to empower youth to reach their highest potential. ',
    ecosystemSegments: ['prevention', 'rehabilitation'],
    focusAreas: ['education', 'employment', 'foster-care', 'shelter', 'victim-care'],
    keyActivities: [
      'I CARE supports youth, up to age 21, who are at risk for or have experienced sex trafficking or other commercial sexual exploitation. The program provides a mental health clinic and a drop-in center.',
      'Our STARS (Surviving Together, Achieving and Reaching for Success) program empowers survivors ages 12-24 to leave sexual exploitation and trafficking by providing emotional support to develop their inner strengths, improve their self-esteem and identify their dreams.',
      'Support for foster families and resources to help current and former foster youth develop independent living skills ',
      'Safe places to live and long-term solutions for youth experiencing homelessness',
      'Comprehensive youth job development program that empowers youth to achieve their employment and educational goals.',
    ],
    geography: ['San Diego'],
    budget: '$21M (2021)',
    yearsInOperation: 54,
    url: 'https://sdyouthservices.org/services/child-sex-trafficking-awareness-and-recovery/',
    ein: '95-2648050',
    address: '3255 Wing St San Diego, CA 92110',
    charityNavigatorRating: 0.96,
    ecosystemInterventions: ['1', '2', '11', '12'],
    recommendedBy: [],
    logo: '/s/SDYS.png',
    latitude: 32.74988702449211,
    longitude: -117.21242521653976,
  },
  {
    id: 'California-Against-Slavery',
    type: '',
    name: 'California Against Slavery',
    mission:
      'To defend the freedom of every person by empowering the people of California to fulfill their obligation to stop human trafficking. ',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['stakeholder-coordination'],
    keyActivities: [
      'Provides a searchable database of organizations combatting trafficking throughout California.',
      'Spotlights the voices and lived experiences of survivors through a video series.',
      'Compiles resources including awareness programs, trainings, and research in one centralized location on their website.',
    ],
    geography: ['San Diego'],
    budget: '$8K (2022)',
    yearsInOperation: 11,
    url: 'https://californiaagainstslavery.org/',
    ein: '46-1824978',
    address: 'P.O. Box 19323, San Diego, CA 92159',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/california-against-slavery.jpg',
    latitude: 32.80158067286938,
    longitude: -117.01051627861048,
  },
  {
    id: 'Shining-Stars',
    type: '',
    name: 'Shining Stars',
    mission:
      'Our mission is to restore, support, and empower women, children (girls and boys), and men who have been affected by sex trafficking and exploitation so that they might have a future of hope and freedom. Our vision is to see each survivor of sex trafficking and exploitation recover from the trauma and abuse of their horrific ordeal.',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['education'],
    keyActivities: [
      'Shining Stars increases community awareness of human trafficking through hosting and participating in events in and around San Diego and with social media.',
      'Shining Stars supports local organizations ministering to victims of human trafficking.  We accomplish this through service projects, helping with organizational needs and supplies, hosting fun events for the victims and those working with them, and one on one mentoring.',
      'Shining Stars desires to establish a 90 day emergency/transitional housing facility to help female and male victims as they move out of human trafficking and transition to longer term programs for restoration and healing.',
      'Shining Stars’ goal is to operate a residential recovery program to help male victims rescued from human trafficking.  To date such a program does not exist in San Diego County and is lacking throughout the US.',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 8,
    url: 'https://www.shiningstarsbreakingchains.org/',
    ein: '47-3847043',
    address: '7931 Broadway Lemon Grove, CA 91945',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/shining-stars.png',
    latitude: 32.74270362841669,
    longitude: -117.02833181839071,
  },
  {
    id: 'Your-Safe-Place',
    type: '',
    name: 'Your Safe Place',
    mission:
      'Your Safe Place provides confidential, comprehensive services to anyone who has experienced domestic violence, family violence, elder abuse, sexual assault, or sex trafficking. At Your Safe Place we provide supportive services in a judgment-free manner that empowers clients to successfully become survivors and move forward with their lives.',
    ecosystemSegments: ['rehabilitation'],
    focusAreas: ['shelter', 'victim-care'],
    keyActivities: [
      'Provide holistic case management and support for survivors of abuse, including domestic abuse and sex trafficking.',
      'Offers mental health counseling, legal services, safety trainings, housing support, immigration services, and more.',
      'Supports trafficking survivors to remove trafficking-related criminal charges from their records',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 0,
    url: 'https://www.sandiego.gov/yoursafeplace',
    ein: '',
    address: '1122 Broadway, 2nd Floor San Diego, CA 92101',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['11', '12'],
    recommendedBy: [],
    logo: '/s/your-safe-place.png',
    latitude: 32.71614401709306,
    longitude: -117.15437641654093,
  },
  {
    id: 'Human-Trafficking-and-CSEC-Advisory-Council',
    type: '',
    name: 'Human Trafficking and CSEC Advisory Council',
    mission:
      'The San Diego Regional Human Trafficking and Commercial Sexual Exploitation of Children Advisory Council’s (HT Advisory Council) vision is a united San Diego region working collaboratively to create long term, systematic change effectively addressing human trafficking and the commercial sexual exploitation of children.',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['law-and-justice', 'research-and-policies', 'stakeholder-coordination'],
    keyActivities: [
      'Bring together stakeholders from throughout the anti-trafficking ecosystem for monthly meetings.',
      'Consolidate research on human trafficking in San Diego in a centralized hub.',
      'Work to enhance victim services by creating an optimized, seamless service delivery system.',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 13,
    url: 'https://htadvisorycouncil.org/',
    ein: '',
    address: '330 W Broadway, San Diego, CA 92101',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/human-trafficking-council.png',
    latitude: 32.716363762966544,
    longitude: -117.16610627606316,
  },
  {
    id: 'Churches-Against-Trafficking',
    type: '',
    name: 'Churches Against Trafficking',
    mission:
      'An organically grown networking group that has come to fruition from the strong desire to connect Christian ministry leaders wanting to engage in the Anti-Trafficking work in San Diego.',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['education', 'fund'],
    keyActivities: [
      'Build a network of San Diego Churches that are engaged in combating human trafficking and raising awareness.',
      'Educate and Engage the Christian community in the anti-trafficking work that is happening San Diego.',
      'Connect the Christian community with local victims service organizations; providing resources, volunteers and finances as needed.',
      'Pray for all of the organizations and ministries; the victims and their advocates working to end human trafficking in San Diego.',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 11,
    url: 'https://www.churchesagainsttrafficking.com/',
    ein: '',
    address: '3900 Lomaland Drive San Diego, CA 92106',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/churches-against-trafficking.png',
    latitude: 32.716563228657705,
    longitude: -117.24984783188417,
  },
  {
    id: 'kNOwMORE',
    type: '',
    name: 'kNOwMORE',
    mission:
      'kNOwMORE is a drama-based and student-centered human trafficking awareness and prevention curriculum, for middle schooland high school-aged youth in San Diego County. The curriculum was designed to help young people recognize the red flags and vulnerabilities around trafficking and equip them to take action for themselves and their peers.',
    ecosystemSegments: ['prevention'],
    focusAreas: ['education', 'training'],
    keyActivities: [
      'Create a curriculum co-facilitated by survivors when available, who engage the participants through drama, dialogue, and informative visuals.',
      'Connect with schools to provide this curriculum in ideally 2-3 hours sessions (can be shortened to 60-90 min).',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 8,
    url: 'https://www.pointloma.edu/centers-institutes/center-justice-reconciliation/know-more-human-trafficking-prevention-program',
    ein: '',
    address: '3900 Lomaland Drive San Diego, CA 92106',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['2'],
    recommendedBy: [],
    logo: '/s/knowmore.png',
    latitude: 32.716563228657705,
    longitude: -117.24984783188417,
  },
  {
    id: 'San-Diego-Trafficking-Prevention-Collective',
    type: '',
    name: 'San Diego Trafficking Prevention Collective',
    mission:
      'The San Diego Trafficking Prevention Collective (SDPTC) is an end-to-end prevention education program that aims to protect every student from exploitation. This comprehensive program works hand-in-hand with school districts to ensure they have the proper prevention measures and agile programming to respond to the unique needs of diverse youth.',
    ecosystemSegments: ['prevention'],
    focusAreas: ['education', 'training'],
    keyActivities: [
      'Train teachers on the prevalence of human trafficking and ways to respond through all staff meetings.',
      'Raise awareness on human trafficking by educating k-12 students with engaging and interactive curricula.',
      'Engage parents who want to bring human trafficking prevention curricula to their schools.',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 9,
    url: 'https://www.sandiegotpc.org/',
    ein: '',
    address: '',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['2'],
    recommendedBy: ['UBS Optimus Foundation'],
    logo: '/s/sdtpc.png',
    collectiveMembers: ['3-Strands-Global-Foundation', 'Global-Communities', 'point-loma-nazarene-university'],
    latitude: 32.817737458853024,
    longitude: -117.10869630199954,
  },
  {
    id: 'STAT',
    type: '',
    name: 'STAT!',
    mission:
      "STAT!'s mission is to advocate for and support victims and survivors, engage in prevention and awareness efforts, and support our community partners in these endeavors. STAT! is made up of members from Soroptimist clubs from around the county.",
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['education', 'fund'],
    keyActivities: [
      'Provides an annual scholarship for a survivor.',
      'Gives mini-grants to local nonprofits leading the fight against human trafficking.',
      'Raise awareness on the issue locally through advertisements, film screenings, and public tabling.',
    ],
    geography: ['San Diego'],
    budget: '',
    yearsInOperation: 13,
    url: 'https://statsandiego.org',
    ein: '',
    address: '',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/stat.png',
    latitude: 32.817737458853024,
    longitude: -117.10869630199954,
  },
  // {
  //   id: 'Live-2-Free',
  //   type: '',
  //   name: 'Live 2 Free',
  //   mission: '',
  //   ecosystemSegments: ['prevention'],
  //   focusAreas: ['education', 'employment'],
  //   keyActivities: [''],
  //   geography: ['San Diego'],
  //   budget: '',
  //   yearsInOperation: 0,
  //   url: 'https://live2free.org/',
  //   ein: '',
  //   address: '55 Fair Drive, Costa Mesa, CA 92626',
  //   charityNavigatorRating: 0,
  //   ecosystemInterventions: ['15'],
  //   recommendedBy: [],
  //   logo: '/s/live2free-retina.jpg',
  //   latitude: 33.66144434163094,
  //   longitude: -117.90095711835961,
  // },
  {
    id: 'Human-Trafficking-Front',
    type: '',
    name: 'Human Trafficking Front',
    mission:
      'We are committed to: 1. Advancing knowledge and responses towards ending abuse, exploitation, and trafficking, particularly that of women and children. 2. Collaborating with governments, the business community, civil society organizations, and key stakeholders to strengthen a multi-faceted response that effectively prevents and addresses forms of trafficking and modern slavery. 3. Supporting concerted efforts to protect trafficking victims, their families, and children who have been abused and exploited via the Internet and mobile technologies. ',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['law-and-justice', 'research-and-policies', 'training'],
    keyActivities: [''],
    geography: ['Florida'],
    budget: '',
    yearsInOperation: 4,
    url: 'https://humantraffickingfront.org/human-trafficking-in-california-complete-prevention-guide/',
    ein: '84-4998853',
    address: '18501 Pines Blvd. Suite 349 Pembroke Pines, FL 33029 ',
    charityNavigatorRating: 0,
    ecosystemInterventions: ['16'],
    recommendedBy: [],
    logo: '/s/Human-Trafficking-Front-Logo.png',
    latitude: 26.010046878929355,
    longitude: -80.39607595907323,
  },
  {
    id: '3-Strands-Global-Foundation',
    type: '',
    name: '3 Strands Global Foundation',
    mission:
      'We are committed to: 1. Advancing knowledge and responses towards ending abuse, exploitation, and trafficking, particularly that of women and children. 2. Collaborating with governments, the business community, civil society organizations, and key stakeholders to strengthen a multi-faceted response that effectively prevents and addresses forms of trafficking and modern slavery. 3. Supporting concerted efforts to protect trafficking victims, their families, and children who have been abused and exploited via the Internet and mobile technologies. ',
    ecosystemSegments: ['ecosystem-capacity-building'],
    focusAreas: ['education', 'stakeholder-coordination'],
    keyActivities: [
      'Educational programs online & in schools',
      'Survivor Care program to empower & equip for a job',
      'Community Awareness Activitiies like 5k run',
    ],
    geography: ['San Diego'],
    budget: '$2.29M (2022)',
    yearsInOperation: 13,
    url: 'https://www.3strandsglobalfoundation.org',
    ein: '27-4594317',
    address: '3941 Park Dr Ste 20-200 El Dorado Hills, CA 95762 USA',
    charityNavigatorRating: 0.92,
    ecosystemInterventions: ['2', '11', '12', '13', '16'],
    recommendedBy: ['UBS Optimus Foundation'],
    logo: '/s/Human-Trafficking-Front-Logo.png',
    // latitude: 38.65582583755484,
    // longitude: -121.06925616039253,
    latitude: 32.570736981795775,
    longitude: -117.08520708129556,
  },
  {
    id: 'Global-Communities',
    type: '',
    name: 'Global Communities',
    mission:
      'Global Communities (formerly PCI) is a global development organization committed to working in partnership with communities worldwide to bring about sustainable, impactful changes that improve the lives and livelihoods of the vulnerable. We believe that the people who understand their needs best are the people of the community itself. Our mission is to work together to save lives, advance equity, and secure strong futures.',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
    focusAreas: ['shelter', 'victim-care'],
    keyActivities: [
      'Increase vulnerable households’ access to healthcare and services',
      'From natural disasters to armed conflicts, Global Communities provides humanitarian assistance to people in need',
      'Economic development programs aim to catalyze sustainable and inclusive economic growth by strengthening the capacity and integration of economic actors to effectively pursue market-based opportunities',
    ],
    geography: ['San Diego', 'Global'],
    budget: '$169.8M (2022)',
    yearsInOperation: 56,
    url: 'https://globalcommunities.org',
    ein: '52-0846183',
    address: '8601 Georgia Ave Ste 800 Silver Spring, MD 20910 USA',
    charityNavigatorRating: 1,
    ecosystemInterventions: ['1', '2', '16'],
    recommendedBy: ['UBS Optimus Foundation'],
    logo: '',
    // latitude: 38.99661845217137,
    // longitude: -77.02809721619789,
    latitude: 32.752186358999275,
    longitude: -117.03501260292875,
  },
  {
    id: 'point-loma-nazarene-university',
    type: '',
    name: 'Point Loma Nazarene University (The Center for Justice & Reconciliation)',
    mission:
      'Point Loma Nazarene University exists to provide higher education in a vital Christian community where minds are engaged and challenged, character is modeled and formed, and service becomes an expression of faith Being of Wesleyan heritage, we aspire to be a learning community where grace is foundational, truth is pursued, and holiness is a way of life',
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
    focusAreas: ['education'],
    keyActivities: ['Undergraduate and Graduate Degree Programs'],
    geography: ['San Diego'],
    budget: '$169.8M (2022)',
    yearsInOperation: 87,
    url: 'https://www.pointloma.edu/centers-institutes/center-justice-reconciliation',
    ein: '95-1644035',
    address: '3900 LOMALAND DRIVE SAN DIEGO, CA 92106 USA',
    charityNavigatorRating: 0.95,
    ecosystemInterventions: ['2', '16'],
    recommendedBy: ['UBS Optimus Foundation'],
    logo: '',
    latitude: 32.716563228657705,
    longitude: -117.24984783188417,
  },
  // PREVIOUS
  {
    id: 'justice-defense-fund',
    type: 'organization',
    name: 'Justice Defense Fund',
    url: 'https://justicedefensefund.org/',
    logo: '/s/logo-justice-defense-fund.png',
    budget: '$2M (2021)',
    mission:
      'JDF is dedicated to empowering survivors of sex trafficking, child sexual abuse material (previously known as “child pornography”) and criminal imagebased sexual abuse to pursue justice through strategic litigation and advocacy support. They also advocate for the adoption of laws and policies that prevent sexual abuse and provide recourse to victims.',
    focusAreas: ['online-exploitation'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['1', '2'],
    keyActivities: ['Fighting online sexual crime', 'Empowering survivors through litigation and advocacy'],
    geography: ['Global'],
    yearsInOperation: 3,
    recommendedBy: [
      'Confidential: Given the sensitive nature of JDF’s work, recommendations are available upon request.',
    ],
  },
  {
    id: 'street-grace',
    type: 'organization',
    name: 'Street Grace',
    url: 'http://streetgrace.org',
    logo: '/s/logo-street-grace.png',
    budget: '$1.8M (2022)',
    mission:
      'Street Grace is a faith-based organization that utilizes evidence-based demand reduction strategies to eradicate CSEC. Street Grace mobilizes community resources – financial, human, and material – to fight CSEC through prevention, protection, policy and pursuit.',
    focusAreas: ['training', 'online-exploitation'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['2', '3'],
    keyActivities: [
      'Educating and training youth and community stakeholders',
      'Launching street teams from local churches',
      'Using artificial intelligence to disrupt online CSEC transactions',
    ],
    geography: ['United States'],
    yearsInOperation: 15,
    recommendedBy: ['Maclellan Foundation', 'Millard Choate: Chairman & CEO of Choate Construction Company'],
    latitude: 33.9412127,
    longitude: -84.2135309,
  },
  {
    id: 'the-contingent',
    type: 'organization',
    name: 'The Contingent',
    url: 'https://www.thecontingent.org/',
    logo: '/s/logo-the-contingent.png',
    budget: '$6.4M (2021)',
    mission: 'The Contingent empowers leaders and mobilizes communities for the common good.',
    focusAreas: ['foster-care'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['3'],
    keyActivities: [
      'Recruiting and retaining of foster families',
      'Improving racial and cultural diversity in company leadership',
    ],
    geography: ['United States'],
    yearsInOperation: 14,
    recommendedBy: [
      'Jeff Grubb: Trustee at the M.J. Murdock Charitable Trust, Strategic Partner at Veber Partners, and Principal at CMP Consulting',
      'Mark Shuholm: President of NW Polymers, Board Chair of The Contingent ',
      'Steve Moore: CEO Emeritus of M.J. Murdock Charitable Trust',
    ],
    latitude: 43.9792797,
    longitude: -120.737257,
  },

  {
    id: 'the-foundation-united',
    type: 'organization',
    name: 'The Foundation United',
    url: 'https://www.thefoundationunited.com/',
    logo: '/s/logo-tfu.png',
    budget: '$1.9M (2022)',
    mission:
      'Foundation United exists to globally eradicate sex trafficking and exploitation by creating systemic change and exposing the root of childhood sexual abuse.',
    focusAreas: ['training', 'online-exploitation'],
    ecosystemSegments: ['prevention', 'ecosystem-capacity-building'],
    ecosystemInterventions: ['4'],
    keyActivities: [
      'Providing training to empower the frontlines, faith communities, and leaders ',
      'Systemically transforming sectors including healthcare, criminal justice, education, churches, and foster families',
    ],
    geography: ['Global'],
    yearsInOperation: 6,
    recommendedBy: [
      'Elaine Lewis: Senior Vice President, Wealth Management Financial Planning Specialist, Financial Advisor at Morgan Stanley ',
      'Bo Ward: Managing Director and Partner at Beacon Pointe Advisors',
    ],
  },
  {
    id: 'nomi-network',
    type: 'organization',
    name: 'Nomi Network',
    url: 'https://www.nominetwork.org/',
    logo: '/s/logo-nomi-network.png',
    budget: '$2.6M (2021)',
    mission:
      'Nomi Network combats human trafficking by creating pathways to safe employment, empowering women and girls to break cycles of slavery in their families and communities..',
    focusAreas: ['employment'],
    ecosystemSegments: ['prevention', 'rehabilitation'],
    ecosystemInterventions: ['5'],
    keyActivities: [
      'Fueling confidence & agency',
      'Addressing barriers to work',
      'Building a network of safety & support ',
      'Facilitating job placement & retention',
    ],
    geography: ['United States', 'India', 'Cambodia'],
    yearsInOperation: 14,
    recommendedBy: ['Jensen Project ', 'Moody Foundation', 'PIMCO Foundation'],
    latitude: 12.5433216,
    longitude: 104.8144914,
  },
  {
    id: 'save-the-children',
    type: 'organization',
    name: 'Save the Children',
    url: 'https://www.savethechildren.org/',
    logo: '/s/logo-save-the-children.png',
    budget: '$1.1B (2022)',
    mission:
      'Save the Children is often told that its aims are impossible – that there has always been child suffering and there always will be. We know it’s impossible only if we make it so. It’s impossible only if we refuse to attempt it.',
    focusAreas: ['education'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['5', '6'],
    keyActivities: [
      'We are global leaders in child  health, education and protection.',
      "We have a proven track record of using donations efficiently and effectively to change children's lives.",
      'We’re transforming the way emergency care is delivered, putting world-class health professionals to work for children in crisis anywhere in the world within 72 hours.',
      'We champion gender equality, recently earning the first nonprofit Gender Fair certification.',
      'We work in the United States, helping more children get ready for kindergarten than any other nonprofit and as the national leader in protecting children in emergencies.',
    ],
    geography: ['San Diego, CA'],
    yearsInOperation: 104,
    recommendedBy: ['UBS'],
    latitude: 28.4282624,
    longitude: 77.0027001,
  },
  {
    id: 'leher',
    type: 'organization',
    name: 'Leher',
    url: 'https://leher.org/',
    logo: '/s/logo-leher.png',
    budget: 'Not listed',
    mission:
      'Leher aims to develop a local community engagement program that prevents children from being abused or exploited. Over a 5 year period, Leher aims to incubate a program to equip communities with awareness, understanding of their situation, skills to mobilize themselves, demand and monitor child protection.',
    focusAreas: ['stakeholder-coordination'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['6', '7'],
    keyActivities: [
      'Leher defines a robust child protection system as one where families, communities, NGOs and government work together and in a coordinated manner to anticipate, prevent and respond to child protection violations. These groups must be guided by policy and law and supported by infrastructure, services and skilled human resources to best serve the interests of children.',
    ],
    geography: ['India'],
    yearsInOperation: 'Not Listed',
    recommendedBy: ['UBS'],
    latitude: 28.5706333,
    longitude: 77.3272147,
  },
  {
    id: 'prerana',
    type: 'organization',
    name: 'Prerana',
    url: 'https://www.preranaantitrafficking.org/',
    logo: '/s/logo-prerana.png',
    budget: 'Not Listed',
    mission:
      'Prerana works to protect the potential and actual women and child victims of human trafficking and other forms of violence, provide comprehensive path-breaking services to uphold their rights, create dignified options for life and lead major advocacy efforts to strengthen the response of the state and the civil society to combat violence against women and children including trafficking with a sustainable, rights-based, development oriented, and participatory approach.',
    focusAreas: ['education', 'shelter'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['7'],
    keyActivities: ['Focuses on services, anti-trafficking center, and child protection '],
    geography: ['India'],
    yearsInOperation: 37,
    recommendedBy: ['UBS'],
    latitude: 19.07283,
    longitude: 72.88261,
  },
  {
    id: 'centre-for-policy-research',
    type: 'organization',
    name: 'Centre for Policy Research',
    url: 'https://cprindia.org/',
    logo: '/s/logo-centre-for-policy-research.png',
    budget: 'Not Listed',
    mission:
      'The Centre for Policy Research (CPR) has been one of India’s leading public policy think tanks since 1973. CPR is a non-profit, non-partisan, independent institution dedicated to conducting research that contributes to high quality scholarship, better policies, and a more robust public discourse about the issues that impact life in India.',
    focusAreas: ['research-and-policies'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['8', '9', '10'],
    keyActivities: [
      'Asking the relevant questions and building evidence on key policy challenges in India',
      'Shaping ideas, building public consensus and providing expert input to policy',
      'Nurturing a policy ecosystem through collaborative platforms',
      'Building the next generation of scholars',
    ],
    geography: ['India'],
    yearsInOperation: 50,
    recommendedBy: ['UBS'],
    latitude: 28.6138954,
    longitude: 77.2090057,
  },
  {
    id: 'unicef',
    type: 'organization',
    name: 'Unicef',
    url: 'https://www.unicef.org/',
    logo: '/s/logo-unicef.png',
    budget: '$1.1B (2022)',
    mission:
      "UNICEF is mandated by the United Nations General Assembly to advocate for the protection of children's rights, to help meet their basic needs and to expand their opportunities to reach their full potential.",
    focusAreas: ['education', 'stakeholder-coordination'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: ['9', '10'],
    keyActivities: [
      'UNICEF works in over 190 countries and territories to save children’s lives, to defend their rights, and to help them fulfil their potential, from early childhood through adolescence. And we never give up.',
    ],
    geography: ['Global'],
    yearsInOperation: 77,
    recommendedBy: ['UBS'],
  },
  {
    id: 'sambodhi',
    type: 'organization',
    name: 'Sambodhi',
    url: 'https://sambodhi.co.in/',
    logo: '/s/logo-sambodhi.png',
    budget: 'Not Listed',
    mission:
      'The insights and solutions we provide help build a better world for our communities and our partners. We are advisors and knowledge partners to donors, governments and implementers as well as public and private sector organizations across the world.',
    focusAreas: ['education'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: [],
    keyActivities: [
      'Public health',
      'renewable energy and climate change',
      'Water, Sanitation, and hygiene',
      'Livelihoods and natural resources',
      'Education and skills',
      'Cross cutting areas',
    ],
    geography: ['Asia', 'Africa'],
    yearsInOperation: '16+',
    recommendedBy: ['UBS'],
    latitude: 11.5024338,
    longitude: 17.7578122,
  },
  {
    id: 'dasra',
    type: 'organization',
    name: 'Dasra',
    url: 'https://www.dasra.org/',
    logo: '/s/logo-dasra.png',
    budget: 'Not Listed',
    mission: 'To transform India, where a billion thrive with dignity and equity',
    focusAreas: ['stakeholder-coordination'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: [],
    keyActivities: [
      'Dasra collaborates with various central and state ministries, individuals, foundations and corporates, to strengthen partnerships between civil society and government, and ensure India achieves its sustainable development goals for all its citizens. We have a sector focus on empowering adolescents and transforming urban sanitation.',
    ],
    geography: ['India'],
    yearsInOperation: 24,
    recommendedBy: ['UBS'],
    latitude: 19.07283,
    longitude: 72.88261,
  },
  {
    id: 'care-portal',
    type: 'organization',
    name: 'Care Portal',
    url: 'https://www.careportal.org/',
    logo: '/s/logo-careportal.png',
    budget: 'Not Listed',
    mission:
      "We believe that children belong in the care of healthy, loving families. And that families should be supported by their local church and caring members of their community. This philosophy – established by our parent organization, The Global Orphan Project, as 'Circles of Care' – puts the child at the center of everything we do and fundamentally guides our work to ensure a healthier, family-style model of care for every child we serve.",
    focusAreas: ['foster-care'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: [],
    keyActivities: ['Not Listed'],
    geography: ['United States'],
    yearsInOperation: 8,
    recommendedBy: ['Not Listed'],
    latitude: 39.100105,
    longitude: -94.5781416,
  },
  {
    id: 'safe-families',
    type: 'organization',
    name: 'Safe Families',
    url: 'https://safe-families.org/',
    logo: '/s/logo-safe-families.png',
    budget: 'Not Listed',
    mission:
      'Safe Families for Children seeks to keep children safe and families together. Safe Families for Children is rooted in faith, fueled by radical hospitality, disruptive generosity, and intentional compassion, to build a network of caring and compassionate volunteers to support families facing social isolation. Our goals are to prevent child abuse and neglect, reduce the number of children entering the child welfare system, and support and stabilize families.',
    focusAreas: ['foster-care'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: [],
    keyActivities: ['Not Listed'],
    geography: ['United States'],
    yearsInOperation: 20,
    recommendedBy: ['Not Listed'],
    latitude: 41.8755616,
    longitude: -87.6244212,
  },
  {
    id: 'altus',
    type: 'organization',
    name: 'Altus',
    url: 'https://altusnow.com/',
    logo: '/s/logo-altus.png',
    budget: 'Not Listed',
    mission:
      'Incorporated in Wyoming, Altus Solutions, Inc. exists to elevate the movement to end and prevent human trafficking.  We accomplish this mission by scaling solutions that accelerate impact and strengthen community response to all forms of trafficking and all the vulnerabilities that drive it.',
    focusAreas: ['training'],
    ecosystemSegments: ['prevention'],
    ecosystemInterventions: [],
    keyActivities: ['Identifying and address vulnerabilites to prevent trafficking'],
    geography: ['United States'],
    yearsInOperation: 4,
    recommendedBy: ['Not Listed'],
    latitude: 43.1700264,
    longitude: -107.568534,
  },
  {
    id: 'international-justice-mission',
    type: 'organization',
    name: 'International Justice Mission (IJM)',
    url: 'https://www.ijm.org/',
    logo: '/s/logo-ijm.png',
    budget: 'Not Listed',
    mission:
      'IJM’s mission is to protect people in poverty from violence by rescuing victims, bringing criminals to justice, restoring survivors to safety and strength, and helping local law enforcement build a safe future that lasts.',
    focusAreas: ['law-and-justice'],
    ecosystemSegments: ['rescue'],
    ecosystemInterventions: [],
    keyActivities: ['Children, women, and men in poverty'],
    geography: ['Global'],
    yearsInOperation: 26,
    recommendedBy: ['Susan Ibarguen', 'Hee-Jung Moon', 'Ken Kroner'],
  },
  {
    id: 'human-trafficking-institute',
    type: 'organization',
    name: 'Human Trafficking Institute',
    url: 'https://traffickinginstitute.org/',
    logo: '/s/logo-human-trafficking-institute.png',
    budget: 'Not Listed',
    mission:
      'The Human Trafficking Institute exists to decimate modern slavery at its source by empowering police and prosecutors to stop traffickers. Working inside criminal justice systems, the Institute provides the embedded experts, world-class training, investigative resources, and evidence-based research necessary to free victims.',
    focusAreas: ['law-and-justice'],
    ecosystemSegments: ['rescue'],
    ecosystemInterventions: [],
    keyActivities: ['Working with government to stop traffickers Education / Model'],
    geography: ['United States', 'Belize', 'Uganda'],
    yearsInOperation: 'Not Listed',
    recommendedBy: ['Andy Code'],
    latitude: 16.8259793,
    longitude: -88.7600927,
  },
  {
    id: 'agami',
    type: 'organization',
    name: 'Agami',
    url: 'https://agami.in',
    logo: '/s/logo-agami.png',
    budget: 'Not Listed',
    mission:
      'Agami is a non-profit organization advancing ideas that serve justice. We do this by identifying innovative ideas, reframing problems, curating leaders, and catalyzing collaborative action – all towards innovation in law and justice. And we do this with a mindset of abundance and transparency.',
    focusAreas: ['law-and-justice'],
    ecosystemSegments: ['ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: ['Innovation in law and justice'],
    geography: ['India'],
    yearsInOperation: 'Not Listed',
    recommendedBy: ['Not Listed'],
    latitude: 12.9767936,
    longitude: 77.590082,
  },
  {
    id: 'allies-against-slavery',
    type: 'organization',
    name: 'Allies Against Slavery',
    url: 'http://www.alliesagainstslavery.org/',
    logo: '/s/logo-allies-against-slavery.png',
    budget: '$720,000',
    mission: 'Restores freedom and dignity to survivors of human trafficking using data, technology, and partnerships',
    focusAreas: ['victim-care'],
    ecosystemSegments: ['rescue', 'ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: [
      'Identifying victims, coordinating care, utilizing software to aggregate statewide data, trends, and insights',
    ],
    geography: ['Texas', 'Louisiana', 'Scaling Nationally'],
    yearsInOperation: 13,
    recommendedBy: ['Eric Stumberg: Co-Founder and CEO of TengoInternet and Jensen Project'],
    latitude: 31.2638905,
    longitude: -98.5456116,
  },
  {
    id: 'safe-house',
    type: 'organization',
    name: 'Safe House',
    url: 'http://www.safehouseproject.org/',
    logo: '/s/logo-safe-house-project.png',
    budget: '$700,000',
    mission:
      'Safe House Project exists to increase survivor identification beyond one percent through education, providing emergency services and placement to survivors, and ensuring every survivor has access to safe housing and holistic care by accelerating safe house capacity and development across America',
    focusAreas: ['shelter'],
    ecosystemSegments: ['rehabilitation', 'ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: [
      'Training for survivor identification, Placing survivors in safe housing, Increasing quality of safe house programs',
    ],
    geography: ['United States'],
    yearsInOperation: 7,
    recommendedBy: [
      'Liam McCormick: Executive Director and Senior Strategist, Family Advisory and Philanthropy Services at UBS, Fox Rock Foundation',
    ],
    latitude: 38.8051095,
    longitude: -77.0470229,
  },
  {
    id: 'many-hopes',
    type: 'organization',
    name: 'Many Hopes',
    url: 'http://www.manyhopes.org/',
    logo: '/s/logo-many-hopes.png',
    budget: '$1.2M',
    mission:
      'Many Hopes rescues children from injustice and equips them to become adults who break cycles of injustice.',
    focusAreas: ['education'],
    ecosystemSegments: ['rescue', 'rehabilitation'],
    ecosystemInterventions: [],
    keyActivities: [
      'Empowering survivor-driven change through education, inspiration, and resources, partnering with high-impact local leaders and organizations to rescue and equip',
    ],
    geography: ['Africa', 'Latin America'],
    yearsInOperation: 14,
    recommendedBy: [
      'Hee-Jung Moon: Former Corporate Attorney',
      'Ken Kroner: Vice Chairman at Exos Asset',
      'Richard Leong: Founder of Two Tunics Legacy Fund Management',
    ],
    latitude: -4.442039,
    longitude: -61.326854,
  },
  {
    id: 'alliance-for-freedom-restoration-and-justice',
    type: 'organization',
    name: 'Alliance for Freedom, Restoration, and Justice',
    url: 'http://www.afrj.com/',
    logo: '/s/logo-afrj.png',
    budget: '390,000',
    mission:
      'AFRJ supports a global collaborative network to end and prevent human trafficking and to build the solutions needed to increase the impact of all',
    focusAreas: ['education', 'stakeholder-coordination'],
    ecosystemSegments: ['ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: [
      'Educates, mobilizes, and supports community leaders including vetted advocates, Provides communities with the ideas, insights, tools, connections, and resources they need to collaborate',
    ],
    geography: ['United States'],
    yearsInOperation: 10,
    recommendedBy: [
      'The Deepak Raghavan Family Foundation',
      'Redman Foundation',
      'The Sanjay Govil Foundation',
      'Gateway Church',
    ],
    latitude: 39.7837304,
    longitude: -100.445882,
  },
  {
    id: 'eagle-venture-fund',
    type: 'organization',
    name: 'Eagle Venture Fund',
    url: 'http://www.eagleventurefund.com/',
    logo: '/s/logo-eagle-venture-fund.png',
    budget: '$46M Assets Under Management',
    mission:
      'The Eagle Freedom Fund invests in founders and companies that are directly combating slavery and human trafficking.',
    focusAreas: ['fund'],
    ecosystemSegments: ['ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: [
      'Impact investing, providing entrepreneurs with investment capital, education, networking, and leadership development',
    ],
    geography: ['Global'],
    yearsInOperation: 7,
    recommendedBy: ['Eric Field: Partner, Western Divisional, President at Steward Partners Global Advisory'],
  },
  {
    id: 'freedom-fund',
    type: 'organization',
    name: 'Freedom Fund',
    url: 'http://www.freedomfund.org',
    logo: '/s/logo-freedom-fund.jpg',
    budget: '$7M',
    mission:
      'The Freedom Fund is a global fund with the sole aim of helping end modern slavery. They invest in and partner with organizations and communities on the frontlines of ending slavery and exploitation. In Brazil, they are focused on anti-CSEC efforts',
    focusAreas: ['fund'],
    ecosystemSegments: ['ecosystem-capacity-building'],
    ecosystemInterventions: [],
    keyActivities: [
      'The Freedom Fund is a global fund with the sole aim of helping end modern slavery. They invest in and partner with organizations and communities on the frontlines of ending slavery and exploitation. In Brazil, they are focused on anti-CSEC efforts',
    ],
    geography: ['United States', 'London'],
    yearsInOperation: 9,
    recommendedBy: [
      'Tom Hall: Managing Director and Global Head of Social Impact & Philanthropy at UBS',
      'Alan McCormick: Partner of Legatum',
    ],
    latitude: 51.5074456,
    longitude: -0.1277653,
  },
];
